import {LitElement, html, css, svg} from 'lit';
import {customElement, property} from 'lit/decorators.js';

@customElement('obi-contacts')
export class ObiContacts extends LitElement {
  @property({type: Boolean}) useCssColor = false;

  private icon = svg`<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
<path d="M2 21C1.45 21 0.979167 20.8042 0.5875 20.4125C0.195833 20.0208 0 19.55 0 19V5C0 4.45 0.195833 3.97917 0.5875 3.5875C0.979167 3.19583 1.45 3 2 3H22C22.55 3 23.0208 3.19583 23.4125 3.5875C23.8042 3.97917 24 4.45 24 5V19C24 19.55 23.8042 20.0208 23.4125 20.4125C23.0208 20.8042 22.55 21 22 21H2ZM15.9 19H22V5H2V19H2.1C2.8 17.75 3.76667 16.7708 5 16.0625C6.23333 15.3542 7.56667 15 9 15C10.4333 15 11.7667 15.3542 13 16.0625C14.2333 16.7708 15.2 17.75 15.9 19ZM9 14C9.83333 14 10.5417 13.7083 11.125 13.125C11.7083 12.5417 12 11.8333 12 11C12 10.1667 11.7083 9.45833 11.125 8.875C10.5417 8.29167 9.83333 8 9 8C8.16667 8 7.45833 8.29167 6.875 8.875C6.29167 9.45833 6 10.1667 6 11C6 11.8333 6.29167 12.5417 6.875 13.125C7.45833 13.7083 8.16667 14 9 14ZM18.5 18L20.5 16L19 14H17.35C17.25 13.7 17.1667 13.3792 17.1 13.0375C17.0333 12.6958 17 12.35 17 12C17 11.65 17.0333 11.3125 17.1 10.9875C17.1667 10.6625 17.25 10.3333 17.35 10H19L20.5 8L18.5 6C17.6 6.7 16.875 7.5875 16.325 8.6625C15.775 9.7375 15.5 10.85 15.5 12C15.5 13.15 15.775 14.2625 16.325 15.3375C16.875 16.4125 17.6 17.3 18.5 18Z" fill="currentColor"/>
</svg>
`;

  private iconCss = svg`<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M2 21C1.45 21 0.979167 20.8042 0.5875 20.4125C0.195833 20.0208 0 19.55 0 19V5C0 4.45 0.195833 3.97917 0.5875 3.5875C0.979167 3.19583 1.45 3 2 3H22C22.55 3 23.0208 3.19583 23.4125 3.5875C23.8042 3.97917 24 4.45 24 5V19C24 19.55 23.8042 20.0208 23.4125 20.4125C23.0208 20.8042 22.55 21 22 21H2ZM15.9 19H22V5H2V19H2.1C2.8 17.75 3.76667 16.7708 5 16.0625C6.23333 15.3542 7.56667 15 9 15C10.4333 15 11.7667 15.3542 13 16.0625C14.2333 16.7708 15.2 17.75 15.9 19ZM9 14C9.83333 14 10.5417 13.7083 11.125 13.125C11.7083 12.5417 12 11.8333 12 11C12 10.1667 11.7083 9.45833 11.125 8.875C10.5417 8.29167 9.83333 8 9 8C8.16667 8 7.45833 8.29167 6.875 8.875C6.29167 9.45833 6 10.1667 6 11C6 11.8333 6.29167 12.5417 6.875 13.125C7.45833 13.7083 8.16667 14 9 14ZM18.5 18L20.5 16L19 14H17.35C17.25 13.7 17.1667 13.3792 17.1 13.0375C17.0333 12.6958 17 12.35 17 12C17 11.65 17.0333 11.3125 17.1 10.9875C17.1667 10.6625 17.25 10.3333 17.35 10H19L20.5 8L18.5 6C17.6 6.7 16.875 7.5875 16.325 8.6625C15.775 9.7375 15.5 10.85 15.5 12C15.5 13.15 15.775 14.2625 16.325 15.3375C16.875 16.4125 17.6 17.3 18.5 18Z" style="fill: var(--element-active-color)"/>
</svg>
`;

  override render() {
    return html`
      <div class="wrapper">${this.useCssColor ? this.iconCss : this.icon}</div>
    `;
  }

  static override styles = css`
    .wrapper {
      height: 100%;
      width: 100%;
      line-height: 0;
    }
    .wrapper > * {
      height: 100%;
      width: 100%;
    }
  `;
}

declare global {
  interface HTMLElementTagNameMap {
    'obi-contacts': ObiContacts;
  }
}
